<script>
import { Pie } from 'vue-chartjs';
import { formatCurrency } from '../../utils';
import 'chartjs-plugin-labels';

const options = {
	responsive: true,
	maintainAspectRatio: false,
	legend: {
		position: 'bottom'
	},
	plugins: {
		labels: {
			render({ label, value }) {
				return '';
			}
		}
	},
	tooltips: {
		callbacks: {
				label: function(tooltipItem, data) {
						let label = data.labels[tooltipItem.index] || '';

						if (label) {
								label += ': ';
						}
						label += '$' + formatCurrency(data.datasets[0].data[tooltipItem.index]);
						return label;
				}
		}
	}
};

export default {
	extends: Pie,
	props: ['data'],
	mounted() {
		this.renderChart(this.data, options);
	},

	watch: {
		data(newData, oldData) {
			this.renderChart(newData, options);
		}
	}
};
</script>
